import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import browser from "web/script/utils/browser";
import userProfiler from "web/script/modules/userprofiler";
import { BannerSize, BannerType, getBannerCampaign } from "web/script/utils/app-banner-campaign";
import analytics from "web/script/analytics/analytics";
import store from "web/redux/store";
import { bannerHidden, bannerVisible, setBannerSize } from "web/redux/ducks/app-download-banner";
import { CampaignRawBranchLink } from "web/script/utils/branch-io";
import SmallAppDownloadBanner from "./small-app-download-banner";
var BRANCH_LINKS = {
  enable_branch_io_feed: CampaignRawBranchLink.Feed,
  enable_branch_io_homepage: CampaignRawBranchLink.Homepage,
  enable_branch_io_is_pdp: CampaignRawBranchLink.ISPDP,
  enable_branch_io_oos_pdp: CampaignRawBranchLink.OOSPDP,
  enable_branch_io_lead_return: CampaignRawBranchLink.LeadReturn
};

function getBranchBannerCampaign() {
  var branchBannerCampaign = getBannerCampaign(analytics.getInitialPageType(), analytics.getInitialSubPageType());

  if (!branchBannerCampaign || branchBannerCampaign.bannerType !== BannerType.Native) {
    return;
  } else {
    branchBannerCampaign.branchLink = BRANCH_LINKS[branchBannerCampaign.flag];
    return branchBannerCampaign;
  }
}

export function AppDownloadBanner() {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isHidden = _useState2[0],
      setIsHidden = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      bannerCampaign = _useState4[0],
      setBannerCampaign = _useState4[1];

  var analyticsEventCategory = "app_banner";

  function hideBanner() {
    setIsHidden(true);
  }

  function showBanner() {
    setIsHidden(false);
  }

  useEffect(function () {
    if (!isHidden && bannerCampaign) {
      store.dispatch(bannerVisible());
      store.dispatch(setBannerSize(bannerCampaign.bannerSize));

      if (!userProfiler.hasAppBannerShown()) {
        userProfiler.saveAppBannerShown();
        analytics.event(analyticsEventCategory, "shown", bannerCampaign.name, true);
      }
    } else {
      store.dispatch(bannerHidden());
    }
  }, [isHidden, bannerCampaign]);
  useEffect(function () {
    var bannerCampaignData = getBranchBannerCampaign();

    if (browser.ios && bannerCampaignData && !userProfiler.hasAppBannerBeenDismissed()) {
      setBannerCampaign(bannerCampaignData);
      showBanner();
    } else {
      hideBanner();
    }
  }, []);

  function onClose() {
    analytics.event(analyticsEventCategory, "dismissed", bannerCampaign ? bannerCampaign.name : "");
    hideBanner();
    userProfiler.saveAppBannerDismissed();
  }

  if (isHidden || !bannerCampaign || bannerCampaign.bannerSize !== BannerSize.Small) {
    return null;
  }

  return React.createElement(SmallAppDownloadBanner, {
    bannerCampaign: bannerCampaign,
    onClose: onClose
  });
}
export default AppDownloadBanner;